// Browser error reporting. Loads the Sentry SDK only when a DSN is configured,
// so builds without one ship no Sentry code to reps' phones beyond this check.
// Settings: lib/observability/sentryOptions.ts (errors only, no PII).

import { sentryDsn, sentryOptions } from "@/lib/observability/sentryOptions";

const dsn = sentryDsn();
if (dsn) {
  import("@sentry/nextjs")
    .then((Sentry) => Sentry.init(sentryOptions(dsn)))
    .catch(() => {
      // Monitoring must never break the app.
    });
}
